import React from 'react';
import { reviewQuoteForServiceAgreement } from '../typewriter/controllers/BookingSubdomainController';
import { TransientAuthType } from '../typewriter/enums/TransientAuthType';
import { handleTokenErrorResponse } from './handleTokenErrorResponse';

export function useServiceAgreementModel(
    authToken: string,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
) {
    const [serviceAgreementModel, setServiceAgreementModel] =
        React.useState<models.ReviewBookingSubdomainServiceAgreementQuoteModel>();

    const fetchModel = React.useCallback(async () => {
        setLoading(true);

        try {
            const result = await reviewQuoteForServiceAgreement(authToken);
            if ((result as any).redirectToUrl != null) {
                window.location.replace((result as any).redirectToUrl);
                return;
            }
            setServiceAgreementModel(result);
            setLoading(false);
        } catch (error: any) {
            setLoading(false);
            handleTokenErrorResponse(error, authToken, 'reviewQuote get');
        }
    }, [authToken, setLoading]);

    React.useEffect(() => {
        if (authToken) {
            fetchModel();
        }
    }, [authToken, fetchModel]);

    return { serviceAgreementModel, fetchModel };
}
